<!-- Blog Detail wrapper -->
<div class="blog-detail section-gap pt-5">
	<div class="container">
		<div class="row">
			<div class="col-sm-12 col-md-12 col-lg-12 mb-3">
				<div class="thumb-content mb-5 blog-content-p">
                    <h4>Modellazione</h4>
					<p>Un'arte tanto antica ha accumulato nei secoli varie tecniche di modellazione. Tra di esse ricordiamo:</p>
                    <h6>Modellazione a mano libera:</h6>
                    <p>È la più antica ed è simile a quanto fanno i bambini quando giocano con la
                        plastilina: si prende una porzione di argilla e, con il solo uso delle mani , si
                        modella la forma desiderata</p>
                    <h6>Modellazione al tornio:</h6>
                    <p>È usata soprattutto per la produzione di vasellame in cui vi sia una
                        simmetria rispetto all&#39;asse di rotazione. Il tornio è un formato da un
                        supporto girevole, simile ad un piatto la cui velocità viene stabilita tramite
                        un pedale, come nel tornio antico, o tramite motorino regolato da
                        reostato, ai giorni nostri. Si pone una data massa di argilla al centro del
                        piatto girevole, avendo cura di posizionarla perfettamente in centro.
                        Quindi si modella con uso delle mani o di altri strumenti mentre si regola
                        la rotazione del tornio stesso. La massa di argilla che si è deciso di usare
                        all&#39;inizio deve essere sufficiente a formare tutto l&#39;oggetto, dal momento
                        che non è possibile aggiungerne in corso d&#39;opera senza pregiudicare la
                        forma data con la modellazione</p>
					<h4>Essiccazione</h4>
                    <p>Qualunque sia la tecnica che si è adottata, è necessario che i manufatti in
                        argilla secchino completamente all&#39;aria. A questa fase va dedicata una
                        particolare cura. Una essiccazione omogenea e uniforme è garanzia di
                        durevolezza dell&#39;oggetto finito e soprattutto della coerenza della sua
                        forma: una essiccazione non uniforme può generare deformazioni. Solo
                        dopo questa fase si può procedere alla cottura. L&#39;essiccazione, infatti,
                        
                        consente che l&#39;oggetto perda l&#39;umidità residua e la sua plasticità.
                        Viene così fissata la forma che si è inteso dargli.
                        Dopo un certo periodo di essiccazione l&#39;argilla raggiunge lo stadio adatto
                        ad essere incisa e decorata. Tale stadio è detto della durezza cuoio: l&#39;argilla è infatti
                        già indurita, ma mantiene ancora una certa residua
                        plasticità.</p>
                    <h4>Cottura</h4>
                    <p>
                        Terminata la delicata fase dell&#39;essiccazione si procede con quella della
                        cottura. Questa avviene in forni appositi, che raggiungono temperature
                        che possono andare parecchio oltre i 1000°C. Il processo può durare
                        anche molte ore. È infatti necessario che la temperatura segua curve di
                        crescita e decrescita graduali e prestabilite, e che tutte le varie fasi
                        abbiano una durata prestabilita. In seguito alla cottura il prodotto subisce
                        un&#39;ulteriore riduzione di volume
                    </p>
                    <h4>Smaltatura e decorazione:</h4>
                    <p>Ci sono molti modi di decorare e colorare la ceramica, anche in relazione
                        al tipo di risultato che si desidera ottenere e alla cottura cui si sottoporrà il
                        pezzo. I colori da ceramica sono essenzialmente di tre tipi:</p>
                    <h6>Ingobbio</h6>
                    <p>
                        Sono specifici colori per la decorazione della ceramica
                        composti da argille già cotte e finissimamente triturate, caolino,
                        sostanze minerali e ossidi. Sono, di fatto, smalti adatti a poter venire
                        applicati sull&#39;oggetto essiccato, ma ancora crudo e da cuocere.
                        Questo permette di saltare un passaggio e cuocere l&#39;oggetto una
                        sola volta, dal momento che questi colori particolari tollerano l&#39;alta
                        temperatura cui si sottopone la ceramica. Gli ingobbi non sono tanto
                        largamente diffusi, essendo costosi e dalle tinte tenui. Perché
                        raggiungano la vetrificazione, inoltre, è necessario portare l&#39;oggetto
                        alla medesima temperatura dell&#39;argilla che si ritrova nella
                        composizione dell&#39;ingobbio. Molti ceramisti che apprezzano la
                        tecnica preparano da sé gli ingobbi che desiderano usare.
                    </p>
                    <h6>Cristalline</h6>
                    <p>Dette anche Vetrine. Sono smalti di tipo vetroso,
                        impermeabili e lucidi. Usualmente trasparenti, solo occasionalmente
                        sono colorate. Lasciano intravedere l&#39;argilla sottostante. Alle
                        cristalline si aggiungono fondenti, quali il germano (che sostituisce il
                        tossico ossido di piombo), gli alcali o i borati. Questo allo scopo di
                        abbassare il punto di fusione.</p>
                    <h6>Smalti</h6>
                    <p>
                        Anch&#39;essi di tipo vetroso.
                        A differenza delle cristalline non sono trasparenti, ma coprenti. Ciò è determinato
                        dalla presenza di componenti quali il feldspato potassico o sodico,bentonite,stagno,e
                        altri ancora.
                        La smaltatura di un pezzo in ceramica ha lo scopo di proteggere il pezzo
                        dall&#39;usura, di facilitarne la pulitura e la manutenzione e di decorarlo.
                        Se il pezzo viene smaltato e non colorato all&#39;ingobbio la smaltatura
                        avviene dopo la cottura e si utilizzano appositi smalti composti da una miscela in
                        vari rapporti di vetro,opacizzanti, fondenti e terre. La smaltatura classica,
                        pertanto è detta applicata al biscotto,ovvero all&#39;oggetto già passato in cottura.
                        Anche per la smaltatura vi sono svariate tecniche, tra le quali ricordiamo:</p>

                        <ul>
                            <li>smaltatura ad aerografo</li>
                            <li>smaltatura per immersione</li>
                            <li>pittura a smalto</li>
                            <li>smaltatura a campana</li>
                            <li>smaltatura elettrostatica</li>
                        </ul>
                    <p>
                        Dopo che si sia provveduto a smaltare la superficie dell&#39;oggetto, si passa
                        alla decorazione pittorica che è usualmente fatta a mano con pennello e
                        colori ceramici. Questi colori ceramici sono ottenuti da ossidi minerali
                        oppure da ossidi metallici addizionati di fondenti o indurenti. Dopo la
                        smaltatura e la decorazione si procede con una seconda cottura, il cui
                        scopo è quello di fissare lo smalto all&#39;oggetto.
                    </p>
                    <h6>La seconda cottura</h6>
                    <p>
                        Come si è detto, gli oggetti sottoposti a smaltatura classica devono subire
                        una seconda cottura per fissare i colori. Tale cottura si attua in forno ad
                        una temperatura compresa tra i 850 e i 970°C, a seconda dei fondenti
                        utilizzati nello smalto.
                        Questa seconda cottura porterà lo smalto a vetrificare, rendendolo lucido
                        e impermeabile. Poiché l&#39;umidità dello smalto è scarsa e i pericoli di
                        rottura sono conseguentemente bassi, la curva della temperatura può
                        essere innalzata più velocemente.
                    </p>
				</div>
				<!-- User Comment section closed -->
			</div>
			<!-- 
			<div class="col-sm-12 col-md-12 col-lg-4">
	            <div class="blog-sidebar">
	               <div class="card border-rad mb-4">
	                  <div class="py-4 px-3">
	                     <h4 class="mb-3"> Search </h4>
	                     <angly-searchNow></angly-searchNow>
	                  </div>
	               </div>
	               <angly-categoriesList [categories]="categories"></angly-categoriesList>
	               <angly-popularPosts [popularPosts]="popularPosts"></angly-popularPosts>
	               <angly-instagramGallary [InstagramImages]="instagramGallary"></angly-instagramGallary>
	               <angly-tags2 [tags]="tags"></angly-tags2>
	            </div>
	        </div> -->
		</div>
	</div>
</div>